module.exports = __webpack_public_path__ + "img/mobile_app_2.072d13a9.png";